import { axiosGetWithCookies } from './helper';

export const fetchTaskDashboardItems = ({
  fromDate,
  severityRating,
  timezone,
  toDate,
  taskCategory,
  patrolType,
  serviceType,
}) => {
  let query = `/tasks/dashboard?`;
  if (Array.isArray(taskCategory)) {
    /* eslint-disable no-param-reassign */
    query += taskCategory.reduce(
      (acc, c) =>
        (acc += c?.id ? `&taskCategory=${c.id}` : `&taskCategory=${c}`),
      '',
    );
  } else if (taskCategory) {
    // it is a string
    query += `&taskCategory=${taskCategory}`;
  }
  if (Array.isArray(patrolType)) {
    /* eslint-disable no-param-reassign */
    query += patrolType.reduce(
      (acc, c) => (acc += c?.id ? `&patrolType=${c.id}` : `&patrolType=${c}`),
      '',
    );
  } else if (patrolType) {
    // it is a string
    query += `&patrolType=${patrolType}`;
  }
  if (Array.isArray(serviceType)) {
    /* eslint-disable no-param-reassign */
    query += serviceType.reduce(
      (acc, c) => (acc += c?.id ? `&serviceType=${c.id}` : `&serviceType=${c}`),
      '',
    );
  } else if (serviceType) {
    // it is a string
    query += `&serviceType=${serviceType}`;
  }

  if (fromDate) query += `&fromDate=${fromDate}`;
  if (severityRating) query += `&severityRating=${severityRating}`;
  if (timezone) query += `&timezone=${timezone}`;
  if (toDate) query += `&toDate=${toDate}`;

  return axiosGetWithCookies(query);
};

export const fetchPatrolDashboardItems = ({
  fromDate,
  timezone,
  toDate,
  patrolCategory,
}) => {
  let query = `/patrols/dashboard?`;
  if (Array.isArray(patrolCategory)) {
    /* eslint-disable no-param-reassign */
    query += patrolCategory.reduce(
      (acc, c) => (acc += c?.id ? `&patrolType=${c.id}` : `&patrolType=${c}`),
      '',
    );
  } else if (patrolCategory) {
    // it is a string
    query += `&patrolType=${patrolCategory}`;
  }

  if (fromDate) query += `&fromDate=${fromDate}`;
  if (timezone) query += `&timezone=${timezone}`;
  if (toDate) query += `&toDate=${toDate}`;

  return axiosGetWithCookies(query);
};
export const fetchVisitDashboardItems = ({ fromDate, timezone, toDate }) => {
  let query = `/regions/sites/visits/dashboard?`;
  if (fromDate) query += `&fromDate=${fromDate}`;
  if (timezone) query += `&timezone=${timezone}`;
  if (toDate) query += `&toDate=${toDate}`;

  return axiosGetWithCookies(query);
};
export const fetchTripDashboardItems = ({
  fromDate,
  timezone,
  toDate,
  serviceType,
}) => {
  let query = `/transport/dashboard?`;
  if (Array.isArray(serviceType)) {
    /* eslint-disable no-param-reassign */
    query += serviceType.reduce(
      (acc, c) => (acc += c?.id ? `&serviceType=${c.id}` : `&serviceType=${c}`),
      '',
    );
  } else if (serviceType) {
    // it is a string
    query += `&serviceType=${serviceType}`;
  }

  if (fromDate) query += `&fromDate=${fromDate}`;
  if (timezone) query += `&timezone=${timezone}`;
  if (toDate) query += `&toDate=${toDate}`;

  return axiosGetWithCookies(query);
};

export const fetchPersonnelDashboardItems = ({ role, status }) => {
  let query = `/users/dashboard?`;
  if (Array.isArray(role)) {
    /* eslint-disable no-param-reassign */
    query += role.reduce(
      (acc, c) => (acc += c?.id ? `&role=${c.id}` : `&role=${c}`),
      '',
    );
  } else if (role) {
    // it is a string
    query += `&role=${role}`;
  }
  if (Array.isArray(status)) {
    /* eslint-disable no-param-reassign */
    query += status.reduce(
      (acc, c) => (acc += c?.id ? `&status=${c.id}` : `&status=${c}`),
      '',
    );
  } else if (status) {
    // it is a string
    query += `&status=${status}`;
  }
  return axiosGetWithCookies(query);
};
export const fetchAssetDashboardItems = ({ category, status }) => {
  let query = `/assets/dashboard?`;
  if (Array.isArray(category)) {
    /* eslint-disable no-param-reassign */
    query += category.reduce(
      (acc, c) => (acc += c?.id ? `&category=${c.id}` : `&category=${c}`),
      '',
    );
  } else if (category) {
    // it is a string
    query += `&category=${category}`;
  }
  if (Array.isArray(status)) {
    query += status.reduce(
      (acc, c) => (acc += c?.id ? `&status=${c.id}` : `&status=${c}`),
      '',
    );
  } else if (status) {
    // it is a string
    query += `&status=${status}`;
  }
  return axiosGetWithCookies(query);
};
